import React, { Component } from 'react'
import { Card, CardContent, CircularProgress, Typography, Divider } from "@mui/material";

export default class LoaderCard extends Component {
    render() {
        return (
            <Card className="widgetCard cardShadow">
                  {this.props.title ?
                        <>
                            <Typography variant="body1" color="grey" align="center" mx={"auto"} width="70%">
                                {this.props.title}
                            </Typography>
                            <Divider light />
                        </> : null}
                <CardContent textAlign="center"
                    sx={{
                        display: "flex",
                        flexDirection:"column",
                        alignItems: "center",
                        justifyContent: "center",
                        minHeight: "20vh",
                    }}>

                  
                    <CircularProgress color="success" />
                </CardContent>
            </Card>
        )
    }
}
